import styled from 'styled-components';

export const Container = styled.div`
  display: none;
  @media (min-width: 1320px) {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    width: minmax(400px, 575px);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    color: #fff;
    font-weight: bold;
    font-size: min(1.5vw, 1em);
    z-index: 2;
    & span {
      text-transform: uppercase;
      margin-right: 10px;
    }
  }
`;

export const Input = styled.input`
  width: 50px;
  text-align: center;
  border: none;
  border-radius: 5px;
  outline: none;
  margin: 0 5px;
  line-height: 1.5rem;
`;
